import {
	HdmCartGetMsiForProductsRequest,
	HdmCartGetMsiForProductsResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class HdmCart<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags HdmCart
	 * @name GetMsiForProducts
	 * @request POST:/store/{storeId}/cart/@self/getMSIForProducts
	 * @response `200` `HdmCartGetMsiForProductsResponse` MSI details retrieved successfully for products
	 */
	getMsiForProducts = (
		storeId: string,
		data: HdmCartGetMsiForProductsRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['getMsiForProducts'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/cart/@self/getMSIForProducts`,
				params: _params,
				body: data,
				methodName: 'getMsiForProducts',
			};
			logger.trace(traceData);
		}
		return this.http.request<HdmCartGetMsiForProductsResponse, any>({
			path: `/store/${storeId}/cart/@self/getMSIForProducts`,
			method: 'POST',
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
